export default __webpack_public_path__ + "static/media/12.16.25 Minutes Reg Mtg.a884aaf0.pdf";